import React, { useRef, useEffect } from 'react';
import { TextArea } from './styled';

export function AutoResizeTextarea({
  style,
  placeholder,
  value,
  onChange,
  onPaste,
  onKeyUp,
  disabled
}) {

  const textareaRef = useRef(null);

  const handleInput = () => {
    const { current } = textareaRef;
    current.style.height = 'auto';
    // Verifica se o valor é vazio ou contém apenas espaços em branco
    if (current.value.trim() === '') {
      current.style.height = '20px'; // Define o tamanho mínimo
    } else {
      current.style.height = current.scrollHeight + 'px';
    }
  };
  useEffect(() => {
    textareaRef?.current?.addEventListener('input', handleInput);
    return () => {
      textareaRef?.current?.removeEventListener('input', handleInput);
    };
  }, []);
  useEffect(() => {
    const { current } = textareaRef;
    if (value.trim() === '') {
      if (current.style.height) {
        current.style.height = '20px'; // Define o tamanho mínimo
      }
    }
  }, [value]);

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      // Impede a ação padrão de quebra de linha no Enter (sem Shift)
      e.preventDefault();
    }
  };
  return (
    <TextArea
      style={style}
      ref={textareaRef}
      rows="1"
      cols="30"
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      onKeyDown={handleKeyDown} // Impede Enter (sem Shift)
      onKeyUp={onKeyUp}
      disabled={disabled}
      onPaste={onPaste}
    />
  );
}